export const AU_PRODUCT_SECTION = 'MistrivoProductSection'

export function parseProductSectionProps(value) {
  if (typeof value === 'string') {
    try { value = JSON.parse(value) } catch { return {} }
  }
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {}
}

const count = (value, fallback, max) => Number.isFinite(Number(value)) && Number(value) >= 1
  ? Math.min(max, Math.floor(Number(value))) : fallback

export function resolveProductSectionConfig(value) {
  const props = parseProductSectionProps(value)
  return {
    platformType: 'shopMixed', showStyle: 'australiaGrid',
    categoryTitle: String(props.categoryTitle || '').trim(),
    mergeFetchData: JSON.stringify(props.sortType ? { sortType: props.sortType } : {}),
    isShowLength: count(props.pageSize, 12, 100),
    isPagination: false, disabledLazyLoad: true,
    gridColumns: count(props.columns, 4, 12),
    tabletColumns: count(props.tabletColumns, 3, 12),
    mobileColumns: count(props.mobileColumns, 2, 12),
    cardOptions: { showComparePrice: props.showComparePrice !== false, showRating: props.showRating !== false },
  }
}

export function collectProductSectionRequests(elements, parent = []) {
  return (elements || []).flatMap((node, index) => {
    const path = [...parent, index]
    const own = node.type === 'originalComponentsItem' && node.config?.name === AU_PRODUCT_SECTION
      ? [{ lvKey: path.join('x'), conf: resolveProductSectionConfig(node.config.props) }] : []
    return [...own, ...collectProductSectionRequests(node.config?.children || node.config?.items, path)]
  })
}

export function productSectionLink(value) {
  const props = parseProductSectionProps(value)
  if (props.moreLink) return props.moreLink
  const query = new URLSearchParams()
  if (props.categoryTitle) query.set('categoryTitle', props.categoryTitle)
  if (props.sortType) query.set('sort', props.sortType)
  const search = query.toString()
  return '/product/GoodsList' + (search ? `?${search}` : '')
}

export function createProductSectionNode(role = 'popular') {
  const latest = role === 'new-arrivals'
  return { type: 'row', config: { classStyle: `au-home-section-${role}`, heightMode: 'auto', children: [{ type: 'col', config: { span: 24, items: [{
    type: 'originalComponentsItem', config: { name: AU_PRODUCT_SECTION, heightMode: 'auto', props: {
      sectionKey: role, title: latest ? 'New Arrivals' : '🔥 Popular Best Seller 🔥',
      columns: latest ? 5 : 4, tabletColumns: 3, mobileColumns: 2,
      pageSize: latest ? 10 : 12, sortType: latest ? 'newest' : 'sales',
      categoryTitle: '', showComparePrice: true, showRating: true,
      showMore: true, moreLabel: 'View More', moreLink: '',
    } },
  }] } }] } }
}

// One initial block at each new design slot. Re-running the configuration must
// preserve merchants' edited blocks instead of duplicating or replacing them.
export function insertAustraliaProductSections(pages) {
  const result = JSON.parse(JSON.stringify(pages))
  for (const page of result) {
    if (!page.elements?.some(node => String(node.config?.classStyle || '').split(/\s+/).includes('au-figma-hero'))) continue
    for (const [role, anchor] of [['popular', 'au-figma-categories'], ['new-arrivals', 'au-figma-story']]) {
      const exists = (nodes) => nodes.some(node => (node.type === 'originalComponentsItem' && node.config?.name === AU_PRODUCT_SECTION && parseProductSectionProps(node.config.props).sectionKey === role) || exists(node.config?.children || node.config?.items || []))
      if (exists(page.elements)) continue
      const index = page.elements.findIndex(node => String(node.config?.classStyle || '').split(/\s+/).includes(anchor))
      if (index >= 0) page.elements.splice(index + 1, 0, createProductSectionNode(role))
    }
    page.langJson ||= {}
    page.langJson['🔥 Popular Best Seller 🔥'] ||= { hans: '🔥 人气热卖 🔥', hant: '🔥 人氣熱賣 🔥', en: '🔥 Popular Best Seller 🔥', ja: '🔥 人気商品 🔥', vi: '🔥 Sản phẩm bán chạy 🔥' }
    page.langJson['New Arrivals'] ||= { hans: '新品推荐', hant: '新品推薦', en: 'New Arrivals', ja: '新着商品', vi: 'Sản phẩm mới' }
    page.langJson['View More'] ||= { hans: '查看更多', hant: '查看更多', en: 'View More', ja: 'もっと見る', vi: 'Xem thêm' }
  }
  return result
}
